import React from 'react';
import { Clock } from 'lucide-react';
import { useCompanyBranding, resolveLogoUrl } from '../../hooks/useCompanyBranding';

export const TerminalHeader = ({ currentTime, children }) => {
  const branding = useCompanyBranding();
  const logoUrl = resolveLogoUrl(branding.logo_url);

  return (
    <div className="max-w-4xl mx-auto mb-6 sm:mb-8 text-center">
      <div className="flex items-center justify-center gap-3 sm:gap-4 mb-3 sm:mb-4">
        {logoUrl ? (
          <img
            src={logoUrl}
            alt={branding.name || 'Logo'}
            className="h-10 w-10 sm:h-12 sm:w-12 object-contain rounded-lg bg-white p-1"
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
            data-testid="terminal-company-logo"
          />
        ) : (
          <Clock className="h-8 w-8 sm:h-10 sm:w-10 text-primary" />
        )}
        <h1 className="text-2xl sm:text-3xl font-bold">Zeiterfassung Terminal</h1>
      </div>
      {children || (
        <>
          <p className="text-base sm:text-xl text-gray-300">
            {currentTime.toLocaleDateString('de-DE', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
          <p className="text-4xl sm:text-5xl font-mono font-bold mt-2 text-primary">
            {currentTime.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
          </p>
        </>
      )}
    </div>
  );
};
